import * as React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

function EmailIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 100 62.6937" xmlns="http://www.w3.org/2000/svg">
      <>
        <g clipPath="url(#clip0_150_2691)">
          <path
            d="M0 0V62.6937H100V0H0ZM49.9967 33.8676L4.17692 1.99534H95.8164L49.9967 33.8676ZM36.3219 26.7842L1.99534 59.3681V2.90655L36.3219 26.7842ZM37.9914 27.9481L49.0522 35.6435L49.9967 36.302L50.9411 35.6435L62.1084 27.875L96.6877 60.6984H3.4985L37.998 27.9481H37.9914ZM63.7778 26.711L98.0047 2.90655V59.1952L63.7845 26.711H63.7778Z"
            fill={props.fill || "#164393"}
          />
        </g>
        <defs>
          <clipPath id="clip0_150_2691">
            <rect width="100" height="62.6937" fill={props.fill || "white"} />
          </clipPath>
        </defs>
      </>
    </SvgIcon>
  );
}

export { EmailIcon };
